<section id="sportTree" class="sport-tree">
  <ul class="list">
      <li *ngFor="let sport of sports;">
          <div class="sport-info" (click)="selectSport(sport)" *ngIf="sport.eventsCount>0">
              <div class="name-wrap">
                <i class="icon-sm m-r s-icon-{{getSportName(sport.id)}} sportid-{{sport.id}}" *ngIf="sport.id > 0"></i>
                <span class="name">{{sport.name}}</span>
              </div>

              <div class="events-count">
                  {{sport.eventsCount}}
                  <i class="arrow-down icon icon-xs icon-chevron-down"></i>
              </div>
          </div>
          <ul class="sub-list region-list" *ngIf="sport.showRegions && sport.eventsCount>0">
            <ng-container  *ngFor="let region of sport.regions;">
                <li [class.live]="isLive" *ngFor="let competition of region.competitions;"  (click)="selectCompetition(competition, sport, region); $event.stopPropagation();">
                  <div class="competition-info"  *ngIf="competition.eventsCount>0">
                    <div class="flex">
                      <span class="region-name">{{competition.regionName}} {{competition.name}}</span>
                    </div>
                    <span class="events-count">
                      {{competition.eventsCount}}
                      <i class="arrow-down icon icon-xs icon-chevron-down" [class.closed]="competition.isSelected"></i>
                    </span>
                  </div>
                  <app-results-sport-selection-container-mobile *ngIf="competition.isSelected" [timeFilterValue]="timeFilter"></app-results-sport-selection-container-mobile>
                </li>
            </ng-container>
          </ul>
      </li>
  </ul>
</section>
